import React from 'react';
import ContentPage from '../ContentPage/ContentPage';

const ImprintPage: React.FC = () => <ContentPage slug="impressum" title="Impressum" />;

export default ImprintPage;
